import * as Animate from "react-reveal";
import {
  BriefCaseIcon,
  GrowthIcon,
  TrophyIcon,
  WorldIcon,
} from "../../../components/svgs";

const benefits = [
  {
    icon: WorldIcon,
    title: "Work remotely",
    desc: "Do focused work from where you work best.",
  },
  {
    icon: GrowthIcon,
    title: "Personal development",
    desc: "Keep learning as the company grows.",
  },
  {
    icon: TrophyIcon,
    title: "Performance bonus",
    desc: "Strong contribution should be recognised.",
  },
  {
    icon: BriefCaseIcon,
    title: "Competitive salary",
    desc: "Compensation designed for meaningful work.",
  },
];

const CareerBenefitsSection = () => {
  return (
    <section className="bg-white py-16 md:py-20 px-4">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {benefits.map((benefit) => {
            return (
              <Animate.Fade bottom key={benefit.title}>
                <div className="h-full rounded-2xl border border-hire-line p-6">
                  <span className="w-11 h-11 rounded-xl bg-primary grid place-items-center mb-4">
                    {/* <span
                      className="w-5 h-5 block"
                      style={{ filter: "brightness(0) invert(1)" }}
                    >
                      <Icon className="w-5 h-5" />
                    </span> */}
                  </span>
                  <h3 className="font-poppins font-extrabold text-lg text-primary mb-1.5">
                    {benefit.title}
                  </h3>
                  <p className="text-gray font-poppins text-sm leading-relaxed m-0">
                    {benefit.desc}
                  </p>
                </div>
              </Animate.Fade>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CareerBenefitsSection;
